import IconDownloadSolid from '@/assets/icons/font_awesome/download-solid.svg?react';
import IconHourglassHalfSolid from '@/assets/icons/font_awesome/hourglass-half-solid.svg?react';
import { UI_PRIMITIVE__button_with_icon_animated } from '@/components/ui/UI_PRIMITIVE__button_with_icon_animated';
import { CONSTANTS_TIME__client } from '@/constants/CONSTANTS_TIME__client';
import { use_dispatch } from '@/hooks/_base/use_dispatch';
import { use_slice_grid2d } from '@/hooks/store/use_slices';
import i18n_grid2d from '@/locales/keys/i18n_grid2d.json';
import { ENUM__i18n_namespace } from '@/services/i18n/ENUM__i18n_namespace';
import { remote_grid2d_download_images } from '@/state/grid2d/grid2d/remote_grid2d_download_images';
import { DTO__entity_with_grid2d } from '@shared/dto/+workspace/workspace_entity/_database_entity_with_grid2d_permissions/DTO__entity_with_grid2d';
import { RequestGrid2dDownloadImages } from '@shared/dto/grid2d/_requests/request_grid2d_download_images';
import { DTO__grid2d } from '@shared/dto/grid2d/DTO__grid2d';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { UI_PRIMITIVE__tooltip } from '../../../../../components/ui/UI_PRIMITIVE__tooltip';

interface Props {
  grid2d: DTO__grid2d;
  entity: DTO__entity_with_grid2d;
}

export function GRID2D_BUTTON_images_download({ grid2d, entity }: Props) {
  /*
   * STORE
   */
  const dispatch = use_dispatch();

  const { t } = useTranslation(ENUM__i18n_namespace.GRID2D);

  const { grid2d_images_download_in_progress } = use_slice_grid2d(['grid2d_images_download_in_progress']);
  /*
   * STATE
   */

  const [is_loading, set_is_loading] = useState(false);

  /*
   * EVENTS
   */
  async function onClick(event: React.MouseEvent<HTMLElement>): Promise<void> {
    if (is_loading) return;

    set_is_loading(true);

    let request = new RequestGrid2dDownloadImages();
    request.workspace_id = grid2d.workspace_id;
    request.entity_type = entity.type;
    request.entity_id = entity._id;
    request.grid2d_id = grid2d._id;

    await dispatch(remote_grid2d_download_images(request));

    set_is_loading(false);
  }

  /*
   * METHODS
   */

  function is_disabled(): boolean {
    return grid2d_images_download_in_progress.has(grid2d._id) || is_loading;
  }

  /*
   * HTML
   */

  if (grid2d.total_images_amount === 0) return null;

  return (
    <UI_PRIMITIVE__tooltip tooltip_title={t(i18n_grid2d.buttons.download_images.tooltip)}>
      <UI_PRIMITIVE__button_with_icon_animated
        variant={'no-border-on-bar'}
        Icon={is_loading ? IconHourglassHalfSolid : IconDownloadSolid}
        disabled={is_disabled()}
        renderDelay={CONSTANTS_TIME__client.TIMEOUT_DELAY_BEFORE_FIRST_ANIMATION_RENDER}
        {...{ onClick }}
        className="p-0 h-[28px] w-[30px] flex items-center justify-center"
        iconClassNameBase="!text-component-item-foreground !size-3"
        iconClassNameHovered="!text-bar-foreground"
      />
    </UI_PRIMITIVE__tooltip>
  );
}
